import request from '@/request'

export async function storeFeedback(data) {
  const response = await request({
    url: `/feedbacks`,
    method: 'post',
    data
  })

  return response.data
}